import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 'calc(100vw - 9rem)',

    [theme.breakpoints.down('md')]: {
      maxWidth: 'calc(100vw - 1rem)'
    }
  },

  title: {
    display: 'flex',
    alignItems: 'center',

    '& > small': {
      margin: '0.125rem 0 0 0.5rem',
      fontSize: theme.size.sm,
      opacity: '0.35'
    }
  },

  selectionOption: {
    color: '#7F8487',
    fontSize: theme.size.sm,
    cursor: 'pointer'
  },

  customSearchRow: {
    display: 'flex',
    alignItems: 'center'
  },

  bottomRow: {
    [theme.breakpoints.down('md')]: {
      display: 'grid !important',
      gridRowGap: '0.25rem',

      '& label': {
        marginLeft: '0.5rem'
      }
    },

    '& .children': {
      [theme.breakpoints.down('md')]: {
        order: '-1',
        display: 'flex !important',
        alignItems: 'center',
        justifyContent: 'start',
        marginTop: '1rem',
        marginBottom: '-0.5rem',
        marginLeft: '0.5rem'
      }
    }
  }
}))

export default useStyles
